export default "__VITE_ASSET__bcbd4c7b__"